import Http from '@/network/http'
export default {
    get: () => {
        return Http.get("v1/me")
    },
    update: (data) => {
        return Http.patch("v1/me", {
            ...data
        })
    },
    changePassword: (data) => {
        return Http.patch("v1/me/changepassword", {
            ...data
        })
    },
}